import { Redirect } from 'react-router-dom';
import type { User } from 'src/types/user';

// Email/password users must verify their email before reaching protected
// areas. (Google sign-ins are always emailVerified === true.) Returns the
// redirect element to short-circuit a guard with, or null to continue.
export const emailVerifiedRedirect = (user: User | null) =>
  user && user.emailVerified === false ? (
    <Redirect to="/verify-email" />
  ) : null;
